import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c850bdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mxa-help-title pt-2",
  "data-test": "title"
}
const _hoisted_2 = { class: "mxa-help-body" }
const _hoisted_3 = { class: "mxa-help-body" }
const _hoisted_4 = { class: "mxa-help-body" }
const _hoisted_5 = { class: "mxa-help-body" }
const _hoisted_6 = { class: "mxa-help-body" }
const _hoisted_7 = { class: "mxa-help-body" }

import BaseAccordion from '@/components/common/parts/BaseAccordion.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HelpDownload',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('body.help.download.title')), 1),
    _createVNode(BaseAccordion, {
      accordionId: "helpDownload1",
      headerTitle: _ctx.$t('body.help.download.1.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.1.body.1')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.1.body.2')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.1.body.3')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.1.body.4')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"]),
    _createVNode(BaseAccordion, {
      accordionId: "helpDownload2",
      headerTitle: _ctx.$t('body.help.download.2.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.2.body.1')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.2.body.2')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"]),
    _createVNode(BaseAccordion, {
      accordionId: "helpDownload3",
      headerTitle: _ctx.$t('body.help.download.3.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.3.body.1')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.3.body.2')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"]),
    _createVNode(BaseAccordion, {
      accordionId: "helpDownload4",
      headerTitle: _ctx.$t('body.help.download.4.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.4.body.1')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.4.body.2')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"]),
    _createVNode(BaseAccordion, {
      accordionId: "helpDownload5",
      headerTitle: _ctx.$t('body.help.download.5.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.5.body.1')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"]),
    _createVNode(BaseAccordion, {
      accordionId: "helpDownload6",
      headerTitle: _ctx.$t('body.help.download.6.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.6.body.1')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.6.body.2')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.download.6.body.3')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"])
  ], 64))
}
}

})